// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5d6e059c","453":"0b515c53","732":"2e81d5d4"}[chunkId] + ".chunk.js";
};